import React, { useMemo } from 'react';
import { Select, Flex } from 'aa-react-ui';

import { useTranslation, SupportedLocale, TKey } from 'locale';

interface LocaleSelectorProps {
    value: string;
    onChange?: (value: string) => void;
}

const LOCALE_LABEL_KEYS: Record<SupportedLocale, TKey> = {
    [SupportedLocale.ar]: TKey.languageAr,
    [SupportedLocale.bg]: TKey.languageBg,
    [SupportedLocale.cs]: TKey.languageCs,
    [SupportedLocale.da]: TKey.languageDa,
    [SupportedLocale.de]: TKey.languageDe,
    [SupportedLocale.enGB]: TKey.languageEnGb,
    [SupportedLocale.enUS]: TKey.languageEnUs,
    [SupportedLocale.es]: TKey.languageEs,
    [SupportedLocale.fi]: TKey.languageFi,
    [SupportedLocale.fr]: TKey.languageFr,
    [SupportedLocale.it]: TKey.languageIt,
    [SupportedLocale.ja]: TKey.languageJa,
    [SupportedLocale.ko]: TKey.languageKo,
    [SupportedLocale.nb]: TKey.languageNb,
    [SupportedLocale.nl]: TKey.languageNl,
    [SupportedLocale.pl]: TKey.languagePl,
    [SupportedLocale.ptBr]: TKey.languagePtBr,
    [SupportedLocale.ru]: TKey.languageRu,
    [SupportedLocale.sv]: TKey.languageSv,
    [SupportedLocale.th]: TKey.languageTh,
    [SupportedLocale.zhCN]: TKey.languageZhCn,
    [SupportedLocale.zhTW]: TKey.languageZhTw
};

const LocaleSelector = (props: LocaleSelectorProps) => {
    const { value, onChange } = props;

    const { t } = useTranslation();

    const options = useMemo(
        () =>
            (Object.entries(LOCALE_LABEL_KEYS) as Array<[SupportedLocale, TKey]>)
                .map(([locale, labelKey]) => ({
                    locale,
                    label: t(labelKey)
                }))
                .sort((a, b) => a.label.localeCompare(b.label)),
        [t]
    );

    return (
        <Flex padding="1rem" flexDirection="row" justifyContent="center" alignItems="center">
            <Select
                value={value}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    onChange && onChange(e.target.value);
                }}>
                {options.map(({ locale, label }) => (
                    <option key={locale} value={locale}>
                        {label}
                    </option>
                ))}
            </Select>
        </Flex>
    );
};

export default LocaleSelector;
